import { useRoutingContext } from 'app/routing_context'
import { PreferencesScreenProps } from 'home/stack/types'
import React, { useLayoutEffect, useMemo } from 'react'
import { usePerformSettingAction } from 'settings/queries/perform_action'
import { useStorePreferences } from 'settings/queries/preferences'
import { SettingsSource } from 'settings/queries/shared/types'
import { SettingsView } from 'settings/screens/settings/views/settings'
import { onBooleanSettingChanged, onPressSetting } from 'settings/utils'
import { StatusBoundary } from 'shared/components/status_boundary'
import { showHeaderTitle } from 'shared/header/header_title'
import { useRecentStoresContext } from 'stores/context'

export function PreferencesScreen({
  navigation,
  route,
}: PreferencesScreenProps) {
  const { handleNavigation } = useRoutingContext()
  const { activeStoreId } = useRecentStoresContext()

  const query = useStorePreferences(activeStoreId)

  useLayoutEffect(
    () => showHeaderTitle(navigation, route.params.title),
    [navigation, route.params.title]
  )

  const settingsSource: SettingsSource = useMemo(
    () => ({
      type: route.params.type,
      storeId: activeStoreId,
    }),
    [activeStoreId, route.params.type]
  )
  const mutation = usePerformSettingAction(settingsSource)

  return (
    <StatusBoundary isLoading={query.isLoading} error={query.error}>
      <SettingsView
        settings={query.data?.settings}
        onPressSetting={setting =>
          onPressSetting(setting, handleNavigation, settingsSource)
        }
        onBooleanSettingChanged={(setting, value) =>
          onBooleanSettingChanged(setting, value, mutation)
        }
      />
    </StatusBoundary>
  )
}
